var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-button',{staticClass:"label--add",attrs:{"variant":"smooth","icon":"tag","size":"tiny"},on:{"click":_vm.addLabel}},[_vm._v("\n  "+_vm._s(_vm.$t('CONTACT_PANEL.LABELS.CONVERSATION.ADD_BUTTON'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }